import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const SectionContainer = styled.div`
  height: auto;
  width: 100%;
  // margin-${props => props.theme.reverseDir}: ${props => props.left};
  // margin-${props => props.theme.dir}: ${props => props.right};
  margin-top: ${props => props.top};
  margin-bottom: 1em;
  padding: 1.063em 0.688em 1.063em 1.063em;
  border-radius: ${props => props.radius};
  background-color: #ffffff;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  display: inline-block;
  margin-bottom: ${props => props.bottom};
  text-align: ${props => props.theme.reverseDir};
`
const Title = styled.h2`
  color: #212529;
  font-size: ${props => props.titleSize};
  font-weight: ${props => props.titleWeight};
  line-height: 1.375em;
  height: 1.375em;
  margin-bottom: 0;
  display: inline-block;
  padding: ${props => props.titlePadding};
`
const View = styled(Link)`
  height: 1.125em;
  width: ${props => (props.theme.dir === 'left' ? '6em' : props.viewwidth)};
  color: #212529;
  font-size: ${props => props.viewsize};
  font-weight: 600;
  line-height: ${props => props.lineheight};
  float: ${props => props.theme.dir};
  margin-right: 0.625em;
  display: block;
  text-align: ${props => props.theme.dir};
`
const SubSection = styled.div`
  width: 100%;
  height: 1.25em;
  justify-content: space-between;
  display: ${props => (props.body ? 'inline-flex' : 'none')};
  padding-right: 0.313em;
`
const Status = styled.p`
  height: 1.125em;
  opacity: 0.5;
  color: #212529;
  font-size: 0.875em;
  line-height: 1.125em;
`
const CreateLink = styled(Link)`
  color: #54ce9d;
  font-size: 0.875em;
  line-height: 1.125em;
  text-align: center;
  float: right;
`
export default function Section(props) {
  const {
    children,
    title,
    view,
    status,
    link,
    width,
    left,
    right,
    bottom,
    viewWidth,
    lineHeight,
    titleSize,
    titleWeight,
    titlePadding,
    path,
    viewsize,
    radius,
    body,
    linkTo,
    top,
    time,
  } = props
  return (
    <SectionContainer
      width={width}
      left={left}
      right={right}
      bottom={bottom}
      radius={radius}
      top={top}
    >
      <Title
        titleSize={titleSize}
        titleWeight={titleWeight}
        titlePadding={titlePadding}
      >
        {title}
      </Title>
      {view && (
        <View
          viewwidth={viewWidth}
          lineheight={lineHeight}
          viewsize={viewsize}
          to={path}
        >
          {view}
        </View>
      )}

      <SubSection body={body}>
        <Status>
          {status}
          {time}
        </Status>
        <CreateLink to={linkTo}>{link}</CreateLink>
      </SubSection>
      {children}
    </SectionContainer>
  )
}

Section.propTypes = {
  children: PropTypes.any,
  title: PropTypes.any,
  view: PropTypes.any,
  status: PropTypes.any,
  link: PropTypes.any,
  width: PropTypes.string,
  left: PropTypes.string,
  right: PropTypes.string,
  bottom: PropTypes.string,
  viewWidth: PropTypes.string,
  lineHeight: PropTypes.string,
  titleSize: PropTypes.string,
  titleWeight: PropTypes.string,
  titlePadding: PropTypes.string,
  path: PropTypes.any,
  viewsize: PropTypes.string,
  body: PropTypes.bool,
  radius: PropTypes.string,
  linkTo: PropTypes.string,
  top: PropTypes.string,
  time: PropTypes.object,
}
Section.defaultProps = {
  view: false,
  status: false,
  link: false,
  width: '100vw',
  left: '-2.667vw',
  viewWidth: '3.9em',
  lineHeight: '1.125em',
  titleSize: '1.125em',
  titleWeight: 'bold',
  path: '',
  viewsize: '0.875em',
  body: true,
  radius: '20px',
  linkTo: '/',
  top: '0',
}
